/* Wild Romantic: muted autoplay for product/section videos + mute toggle.
   Targets any element with class "wr-autoplay" (native <video>, YouTube or Vimeo iframe). */
(function () {
  var SEL = '.wr-autoplay';

  function isVisible(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < window.innerHeight && r.left < window.innerWidth;
  }
  function post(iframe, data) {
    try { iframe.contentWindow.postMessage(JSON.stringify(data), '*'); } catch (e) {}
  }
  function isYT(el) { return el.tagName === 'IFRAME' && el.classList.contains('js-youtube'); }
  function isVimeo(el) { return el.tagName === 'IFRAME' && el.classList.contains('js-vimeo'); }

  function play(el) {
    if (el.tagName === 'VIDEO') {
      el.muted = el.dataset.wrUnmuted !== 'true';
      var p = el.play();
      if (p && p.catch) p.catch(function () { el.muted = true; el.play().catch(function () {}); });
    } else if (isYT(el)) {
      post(el, { event: 'command', func: 'playVideo', args: [] });
    } else if (isVimeo(el)) {
      post(el, { method: 'play' });
    }
  }
  function pause(el) {
    if (el.tagName === 'VIDEO') el.pause();
    else if (isYT(el)) post(el, { event: 'command', func: 'pauseVideo', args: [] });
    else if (isVimeo(el)) post(el, { method: 'pause' });
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? play(e.target) : pause(e.target); });
      }, { threshold: 0.2 })
    : null;

  function init(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.wrInit) return;
      el.dataset.wrInit = '1';
      if (el.tagName === 'VIDEO') {
        el.muted = true;
        el.loop = true;
        el.setAttribute('muted', '');
        el.setAttribute('playsinline', '');
        el.setAttribute('webkit-playsinline', '');
        el.removeAttribute('controls');
      }
      if (io) io.observe(el); else play(el);
    });
  }

  // Dawn pauses every video when the gallery slide changes; resume the ones still on screen.
  function patchPauseAll() {
    var orig = window.pauseAllMedia;
    if (typeof orig !== 'function' || orig.__wr) return;
    var wrapped = function () {
      orig.apply(this, arguments);
      setTimeout(function () {
        document.querySelectorAll(SEL).forEach(function (el) { if (isVisible(el)) play(el); });
      }, 60);
    };
    wrapped.__wr = true;
    window.pauseAllMedia = wrapped;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wr-mute-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('[data-wr-video]');
    var el = wrap && wrap.querySelector(SEL);
    if (!el) return;
    var unmute = btn.getAttribute('aria-pressed') !== 'true';
    btn.setAttribute('aria-pressed', unmute ? 'true' : 'false');
    btn.setAttribute('aria-label', unmute ? btn.dataset.labelMute : btn.dataset.labelUnmute);
    if (el.tagName === 'VIDEO') {
      el.dataset.wrUnmuted = unmute ? 'true' : 'false';
      el.muted = !unmute;
      el.play().catch(function () {});
    } else if (isYT(el)) {
      post(el, { event: 'command', func: unmute ? 'unMute' : 'mute', args: [] });
      if (unmute) post(el, { event: 'command', func: 'setVolume', args: [100] });
    } else if (isVimeo(el)) {
      post(el, { method: 'setMuted', value: !unmute });
      post(el, { method: 'setVolume', value: unmute ? 1 : 0 });
    }
  }, true);

  // Resume on-screen videos when the tab becomes visible again (browsers pause media in background tabs)
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    document.querySelectorAll(SEL).forEach(function (el) { if (isVisible(el)) play(el); });
  });

  function boot() { init(); patchPauseAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', patchPauseAll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { init(); break; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* Wild Romantic: back-to-top button. Appears after scrolling down, sits bottom-right,
   and lifts above the product page's sticky add-to-cart bar when that bar is showing. */
(function () {
  function initBackToTop() {
    if (document.querySelector('.wr-back-to-top')) return;

    var css = document.createElement('style');
    css.textContent =
      '.wr-back-to-top{position:fixed;right:20px;bottom:calc(20px + var(--wr-btt-offset,0px));z-index:40;' +
      'width:46px;height:46px;border-radius:50%;border:0;padding:0;cursor:pointer;display:flex;align-items:center;' +
      'justify-content:center;background:rgb(200,16,46);color:#fff;box-shadow:0 4px 14px rgba(0,0,0,.18);' +
      'opacity:0;visibility:hidden;transform:translateY(10px);transition:opacity .25s ease,transform .25s ease,visibility .25s,bottom .25s ease;}' +
      '.wr-back-to-top.is-visible{opacity:1;visibility:visible;transform:translateY(0);}' +
      '.wr-back-to-top:hover{background:rgb(170,12,38);}' +
      '.wr-back-to-top:focus-visible{outline:2px solid #fff;outline-offset:-5px;}' +
      '.wr-back-to-top svg{width:20px;height:20px;display:block;}' +
      '@media (max-width:749px){.wr-back-to-top{right:14px;bottom:calc(14px + var(--wr-btt-offset,0px));width:42px;height:42px;}}';
    document.head.appendChild(css);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wr-back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(btn);

    var ticking = false;
    function update() {
      ticking = false;
      btn.classList.toggle('is-visible', window.scrollY > 600);
      var bar = document.getElementById('stickyBar');
      var offset = 0;
      if (bar) {
        var cs = getComputedStyle(bar);
        var r = bar.getBoundingClientRect();
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top < window.innerHeight && r.bottom > window.innerHeight - 5) {
          offset = Math.round(window.innerHeight - r.top);
        }
      }
      btn.style.setProperty('--wr-btt-offset', offset + 'px');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    // Sticky add-to-cart bar slides in with an animation, so re-check when it changes
    var sb = document.getElementById('stickyBar');
    if (sb && window.MutationObserver) new MutationObserver(onScroll).observe(sb, { attributes: true });
    if (sb) sb.addEventListener('transitionend', onScroll);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBackToTop);
  else initBackToTop();
})();
